module.exports = __webpack_public_path__ + "media/images/favicon-dd1858c9c743c72194fce89934c14ea2.ico";